'use client'

import { getPlayListVideoSort, setPlayListVideoSort } from 'app/lib/playListVideoSort'
import { createContext, useContext, useState, type ReactNode } from 'react'
import type { PlayListVideoSortType } from '~/features/play_list/components/buttons/PlayListVideoSortButton/constants'

type PlayListVideoSortContextType = {
  sortType: PlayListVideoSortType | null
  updateSortType: (sortType: PlayListVideoSortType) => void
}

const PlayListVideoSortContext = createContext<PlayListVideoSortContextType | undefined>(undefined)

export const PlayListVideoSortProvider = ({ children }: { children: ReactNode }) => {
  const [sortType, setSortType] = useState<PlayListVideoSortType | null>(() =>
    getPlayListVideoSort(),
  )

  const updateSortType = (newSortType: PlayListVideoSortType) => {
    setPlayListVideoSort(newSortType)
    setSortType(newSortType)
  }

  return (
    <PlayListVideoSortContext.Provider value={{ sortType, updateSortType }}>
      {children}
    </PlayListVideoSortContext.Provider>
  )
}

export const usePlayListVideoSort = () => {
  const context = useContext(PlayListVideoSortContext)
  if (context === undefined) {
    throw new Error('usePlayListVideoSort must be used within PlayListVideoSortProvider')
  }
  return context
}
